import { IArtifacts } from '../model/IArtifacts'
import axiosInstance from '../services/apis'

export const getArtifacts = async (
    clientCode: string,
    language: number,
    useCVD: boolean
) => {
    const response: { values: IArtifacts } = await axiosInstance.get(
        `/api/IMKPolicy/imk/${clientCode}/${language}/${useCVD}`
    )
    return response
}
